export const LOBBY_CATEGORY_CLICK = 'lobby_category_click';
export const LOBBY_INFO_CLICK = 'lobby_info_click';
export const LOBBY_PLAY = 'lobby_play';
export const LOBBY_LIMIT_CHOICE_SHOW = 'lobby_limit_choice_show';
export const LOBBY_LIMIT_CHOICE_CLOSE = 'lobby_limit_choice_close';
export const LOBBY_FAVORITE = 'lobby_favorite';
export const LOBBY_INITIAL_DATA = 'initial_player';
export const LOBBY_MORE_CATEGORIES = 'lobby_more_categories';
export const LOBBY_DESKTOP_FULLSCREEN_CLICK = 'click_lobby_desktop_fullscreen';
export const GAME_MENU_PLAYER_HISTORY_CLICK = 'game_menu_player_history_click';
export const GAME_MENU_PLAYER_HISTORY_DAILY = 'game_menu_player_history_daily';
export const MENU_TAP = 'menu_tap';

export const LOADING_STATUS_INITIALIZATION = 'initialization';
export const LOADING_STATUS_SUCCESS = 'success';
export const LOADING_STATUS_ERROR = 'error';

export const EXTERNAL_VISITOR = 'external';
export const INTERNAL_VISITOR = 'internal';

export const CHANGE_ORIENTATION = 'change_orientation';
